import { Handle, Position, type NodeProps } from "@xyflow/react";
import { Users01 } from "@untitledui/icons";
import type { AgentType } from "@/types/workflow";
import { useTranslation } from "react-i18next";

export const AgentNode = ({ data }: NodeProps) => {
    const { t } = useTranslation('pages:workflows-admin');
    const agentType = (data?.agent_type as AgentType | undefined);
    const dataLabel = (data?.label as string) || "";

    const agentTypeLabels: Record<AgentType, string> = {
        postino: t('workflows.editor.agentTypes.postino'),
        classificatore: t('workflows.editor.agentTypes.classificatore'),
        parser: t('workflows.editor.agentTypes.parser'),
        validatore: t('workflows.editor.agentTypes.validatore'),
    };

    const label = agentType ? agentTypeLabels[agentType] : dataLabel || t('workflows.editor.defaultLabels.agent');

    return (
        <div className="rounded-lg bg-utility-blue-50 border-2 border-utility-blue-500 shadow-md min-w-[150px]">
            <Handle type="target" position={Position.Top} className="w-3 h-3 bg-utility-blue-500" />
            <Handle type="source" position={Position.Bottom} className="w-3 h-3 bg-utility-blue-500" />
            <div className="flex flex-col gap-1 px-3 py-2">
                <div className="flex items-center gap-2">
                    <Users01 className="size-4 text-utility-blue-600" />
                    <span className="text-sm font-semibold text-utility-blue-700">{label}</span>
                </div>
                {agentType && (
                    <span className="text-xs text-utility-blue-600 opacity-75">{agentType}</span>
                )}
            </div>
        </div>
    );
};
